import React, { useEffect, useState } from 'react';
import { Button, Form, Input, message, Select } from 'antd';
import CommonCard from '../../../../global/card';
import CommonForm from '../../../../global/form';
import CommonDatePicker from '../../../../global/datePicker';
import SOURCES from '../../../../../utils/constants';
import { useKey } from '../../../../../services/useKey';
import useGet from '../../../../../services/useGet';
import LocalStorageService from '../../../../../utils/localStorageServices';
import dayjs from 'dayjs';
import { useGenericQuery } from '../../../../../queries/use-generic-query';
import { QUERY_KEYS } from '../../../../../lib/query-constants';

const localStorageServices = LocalStorageService.getService();

const EnhancedAdvanceSearchLeadsImported = ({
    setShowAdvanceSearch,
    setAdvanceSearch,
    advanceSearch,
    getAdvanceSearchData,
    showSearchTerm = true,
}) => {
    const [searched, setSearched] = useState(false);
    const [form] = Form.useForm();
    const currentUser = localStorageServices.getCurrentUser();
    const userRole = currentUser?.user?.userRole;

    // const { callApi: getUsers, data: users } = useGet({
    //     endpoint: `admin/users?ignorePagination=true`,
    // });

    // const {
    //     callApi: getLeadSourcesOptions,
    //     data: leadSource,
    // } = useGet({
    //     endpoint: `leadsource/options`,
    // });

    const { data: users } = useGenericQuery({
        endpoint: `admin/users?ignorePagination=true`,
        queryKey: QUERY_KEYS.users.lists(),
        queryParams: { ignorePagination: true },
        enabled: userRole === SOURCES.USER_ROLE_ADMIN
    })

    const { data: leadSource } = useGenericQuery({
        endpoint: `leadsource/options`,
        queryKey: QUERY_KEYS.leadSourceOptions.lists(),
    })
    const getUserOptions = () => {
        if (Array.isArray(users?.users) && users.users.length > 0) {
            return users.users.map((user) => ({
                label: `${user.name} (${user.email})`,
                value: user.email,
            }));
        }
        return [];
    };

    const getLeadSourceOptions = () => {
        if (Array.isArray(leadSource) && leadSource.length > 0) {
            return leadSource.map((item) => ({
                label: item.title,
                value: item.key,
            }));
        }
        return [];
    };

    useKey(() => setSearched(true), "Enter");
    useKey(() => {
        setShowAdvanceSearch(false);
        setAdvanceSearch({
            ...advanceSearch,
            advance_search_enabled: searched
                ? SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_CLOSED_SEARCH_FORM
                : SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER,
        });
    }, "Escape");

    // useEffect(() => {
    //     getLeadSourcesOptions();
    //     if (userRole === SOURCES.USER_ROLE_ADMIN) {
    //         getUsers();
    //     }
    // }, []);

    const onSearch = () => {
        form
            .validateFields()
            .then(async (values) => {
                const hasValues =
                    values.startDate ||
                    values.endDate ||
                    values.leadSource ||
                    values.user ||
                    values.searchTerm;

                if (!hasValues) {
                    setAdvanceSearch({
                        ...advanceSearch,
                        advance_search_enabled:
                            SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER,
                    });
                    message.error("Please fill at least one field.");
                    return;
                }

                const userTZ = dayjs.tz.guess(); // 🔥 user's real timezone

                setAdvanceSearch({
                    ...advanceSearch,

                    startDate: values.startDate
                        ? dayjs(values.startDate)
                            .tz(userTZ)
                            .startOf("day")
                            .format() // ISO with offset
                        : "",

                    endDate: values.endDate
                        ? dayjs(values.endDate)
                            .tz(userTZ)
                            .endOf("day")
                            .format()
                        : "",

                    leadSource: values.leadSource || "",
                    user: values.user || "",
                    searchTerm: values.searchTerm || "",

                    advance_search_enabled:
                        SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_FILTER,
                });
            })
            .catch((err) => {
                console.log("Validation failed", err);
            });
    };


    const formData = [
        {
            label: "Start Date",
            name: "startDate",
            inputType: SOURCES.FORMINPUTTYPES.DATE,
            type: "date",
            placeholder: "Start Date",
            required: false,
            span: 12,
        },
        {
            label: "End Date",
            name: "endDate",
            inputType: SOURCES.FORMINPUTTYPES.DATE,
            type: "date",
            placeholder: "End Date",
            required: false,
            span: 12,
        },
        {
            label: "Lead Source",
            name: "leadSource",
            inputType: SOURCES.FORMINPUTTYPES.SELECT,
            type: "select",
            placeholder: "Filter Via Lead Source",
            required: false,
            options: getLeadSourceOptions(),
            span: 24,
        },
        ...(userRole === SOURCES.USER_ROLE_ADMIN
            ? [
                {
                    label: "User",
                    name: "user",
                    inputType: SOURCES.FORMINPUTTYPES.SELECT,
                    type: "select",
                    placeholder: "Filter Via User",
                    required: false,
                    options: getUserOptions(),
                    span: 24,
                },
            ]
            : []),
        ...(showSearchTerm ? [{
            label: "Search",
            name: "searchTerm",
            inputType: SOURCES.FORMINPUTTYPES.INPUT,
            type: "text",
            placeholder: "Search",
            required: false,
            span: 24,
        }] : [])
    ];

    return (
        <CommonCard
            title="Advance Search"
            isExtraButton={{
                show: [
                    "startDate",
                    "endDate",
                    "leadSource",
                    "user",
                    "searchTerm",
                ].some((key) => advanceSearch[key] && advanceSearch[key] !== ""),
                data: [
                    {
                        title: "Clear",
                        onClick: () => {
                            setAdvanceSearch({
                                ...advanceSearch,
                                startDate: "",
                                endDate: "",
                                leadSource: "",
                                user: "",
                                searchTerm: "",
                                advance_search_enabled:
                                    SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER,
                            });
                            form.resetFields();
                        },
                    }
                ]
            }}
            className={"max-w-[650px] w-full shadow-2xl"}
        >
            <CommonForm
                data={formData}
                className="mt-4"
                layoutType="vertical"
                form={form}
            />
            <div className="flex justify-end">
                <Button
                    key="confirm"
                    type="primary"
                    className="!bg-primary text-white h-10 min-w-[130px]"
                    onClick={onSearch}
                >
                    Search
                </Button>
            </div>
        </CommonCard>
    );
};

export default EnhancedAdvanceSearchLeadsImported;